__turbopack_context__.v({
  "image": "gallery-image-module__Rm3hta__image",
  "missing": "gallery-image-module__Rm3hta__missing",
  "wrapper": "gallery-image-module__Rm3hta__wrapper",
});
